<script setup>
import { useControllable } from '@cnd_fe/composables'
import HOption from './HOption.vue'

const props = defineProps({
  modelValue: [String, Number, Array], // Array for multiple
  multiple: Boolean,
  disabled: Boolean,
  name: String,
  required: Boolean,
  size: Number,
  items: Array
})

const emit = defineEmits(['update:modelValue', 'change', 'blur', 'focus'])

// 1. useControllable을 올바르게 호출하고, 반환된 WritableComputedRef를 사용합니다.
// 2. multiple일 때 기본값을 빈 배열로 수정합니다.
const current = useControllable(props, 'modelValue', {
  emit,
  defaultValue: props.multiple ? [] : ''
})

// 3. v-model이 modelValue 업데이트를 처리하므로, change 이벤트만 emit합니다.
const onChange = () => {
  emit('change', current.value)
}
</script>

<template>
  <select
    v-model="current"
    :multiple="props.multiple"
    :disabled="props.disabled"
    :name="props.name"
    :required="props.required"
    :class="$attrs.class"
    @change="onChange"
    @blur="(e) => emit('blur', e)"
    @focus="(e) => emit('focus', e)"
  >
    <template v-if="items?.length">
      <!-- HOption의 value prop을 바인딩해야 합니다. -->
      <HOption v-for="option in items" :key="option.key" :value="option.value" :disabled="option.disabled">
        {{ option.label }}
      </HOption>
    </template>
    <slot v-else />
  </select>
</template>
